export class CategoryModel {
    public id: number;
    public value: string;
    public description: string;
    public createdAt: string;
    public updatedAt: string;
    public maincategory: number;
    public image: string;

    constructor(res: any) {
        this.id = res.id;
        this.value = res.value || '';
        this.description = res.description || '';
        this.createdAt = res.createdAt || '';
        this.updatedAt = res.updatedAt || '';
        this.maincategory = res.maincategory;
        this.image = res.image || '';
    }
}